<template>
  <Cmask v-show="showPopup" @click="closePopup">
    <div class="container">
      <div class="content" :style="{ font: fontOption }">
        <div style="height: 1000px; background: red"></div>
      </div>
      <div class="line">
        <span v-for="item in 5" :key="item"></span>
        <img
          class="guanbi"
          src="./../../../assets/imgs/close.png"
          @click="closePopup"
          alt=""
        />
        <!-- <i class="iconfont icon-guanbi" @click="closePopup"></i> -->
      </div>
    </div>
  </Cmask>
</template>

<script>
export default {
  name: "Popup",
  props: {
    fontOption: {
      //内容区的字体样式 是否加粗 字体大小/行高 子体
      type: String,
      default: "normal bold 12px/20px arial,sans-serif",
    },
    showPopup: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
  created() {},
  mounted() {},
  data() {
    return {
      content: "zhouxinpu\n\t\n\t周信普\n", //内容
    };
  },
  methods: {
    closePopup() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  z-index: 1000;
  position: absolute;
  background: #f5f5f5;
  left: 50%;
  padding: 100px 62px 75px;
  width: 618px;
  top: 100px;
  height: 780px;
  box-sizing: border-box;
  transform: translateX(-50%);
  display: flex;
  .content {
    flex: 1;
    box-sizing: border-box;
    border: 1px solid #ccc;
    overflow-y: auto;
    padding: 10px 20px;
  }
  .line {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 90px;
    display: flex;
    flex-direction: column;
    span {
      width: 4px;
      height: 10px;
      margin-top: 7px;
      background: #fff;
    }
  }
  .guanbi {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: -84px;
    left: 50%;
    color: #fff;
    transform: translateX(-50%);
  }
}
</style>
